export type ThinkingLevel = "low" | "med" | "high" | "max"

export function isThinkingLevel(value: unknown): value is ThinkingLevel {
    return value === "low" || value === "med" || value === "high" || value === "max"
}

export interface AgentTarget {
    harnessId: string
    modelId: string
    /** Absent on legacy targets, which retain their previous default. */
    thinking?: ThinkingLevel
}

export function agentTargetId(target: AgentTarget): string {
    // Keep legacy option ids while distinguishing pairs from model ids that
    // themselves contain a thinking-like suffix.
    return target.thinking ? JSON.stringify([target.harnessId, target.modelId, target.thinking]) : `${target.harnessId}:${target.modelId}`
}
